module.exports = __webpack_public_path__ + "img/borderThreeCircularCloudWhite.559475ab.svg";